export default __webpack_public_path__ + "static/media/linkedin.fa38aeaf.svg";